import { motion } from 'motion/react';
import { process as proc } from '../../../content/agencyCopy';
import RevealOnScroll from '../RevealOnScroll';

export default function Process() {
  return (
    <section
      id="process"
      className="fa-grid px-6 py-24 md:py-32"
      style={{ background: 'var(--fa-paper)', borderTop: '1px solid var(--fa-rule)' }}
    >
      <RevealOnScroll className="max-w-[1120px] mx-auto">
        <div className="fa-label fa-header-rule mb-5">
          <span className="flex items-center gap-3">
            <span className="fa-status-dot fa-status-dot--live" aria-hidden="true" />
            {proc.label}
          </span>
        </div>
        <h2
          className="font-heading text-[30px] md:text-[42px] font-semibold"
          style={{ maxWidth: '20ch', color: 'var(--fa-ink)', textWrap: 'balance' }}
        >
          {proc.headline}
        </h2>
        <p className="mt-5 text-[16px] fa-glow-text fa-glow-text--muted" style={{ maxWidth: '56ch' }}>
          {proc.intro}
        </p>

        <div className="mt-16 grid gap-y-12 md:gap-x-6 md:grid-cols-3">
          {proc.steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.1, ease: [0.2, 0.7, 0.2, 1] }}
              className="relative md:pr-6"
            >
              {/* Step rule with the phase number sitting on it */}
              <div className="flex items-center gap-4">
                <span className="fa-ref fa-ref--signal" style={{ fontSize: 11 }}>{s.n}</span>
                <span className="flex-1 h-px" style={{ background: 'var(--fa-rule)' }} aria-hidden="true" />
                {/* Arrow into the next phase, desktop only */}
                {i < proc.steps.length - 1 && (
                  <span className="hidden md:inline fa-ref" style={{ color: 'var(--fa-signal)' }} aria-hidden="true">
                    →
                  </span>
                )}
              </div>

              <h3 className="font-display text-[23px] md:text-[25px] mt-5" style={{ color: 'var(--fa-ink)' }}>
                {s.title}
              </h3>

              <div className="mt-3 flex items-center gap-2 max-w-[180px]">
                <span className="fa-dim__cap" aria-hidden="true" />
                <span className="fa-dim flex-1"><span>{s.span}</span></span>
                <span className="fa-dim__cap" aria-hidden="true" />
              </div>

              <p className="mt-5 text-[15px] fa-glow-text" style={{ maxWidth: '38ch' }}>
                {s.body}
              </p>
            </motion.div>
          ))}
        </div>
      </RevealOnScroll>
    </section>
  );
}
